@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ListButton {
  @extend %font-family-primary;

  background: $theme-color-background;
  border-radius: 2px;
  box-shadow: 0 0 0 3px $theme-color-background;
  color: $theme-filter-icon-color;
  cursor: pointer;
  font-weight: $font-weight-normal;
  display: inline-block;
  line-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  height: 18px;
  width: 18px;
  margin-left: 3.5px;
  min-width: max-content;

  &:disabled {
    color: $color-grey-disabled;
    pointer-events: none;
    opacity: 0.3;
  }

  &:hover {
    background: $theme-color-dark-secondary-button-hover;
    border-radius: 2px;
    box-shadow: 0 0 0 3px $theme-color-dark-secondary-button-hover;
  }

  &:active,
  &:focus {
    background: $theme-color-checkbox-disabled-checked-background;
    border-radius: 2px;
    box-shadow: 0 0 0 3px $theme-color-checkbox-disabled-checked-background;
  }

  &.isFocus {
    background: $theme-color-checkbox-disabled-checked-background;
    border-radius: 2px;
    box-shadow: 0 0 0 3px $theme-color-checkbox-disabled-checked-background;
  }

  &.counter {
    height: auto;
    width: auto;
    border-radius: 4px;
    padding: 2px 6px;
    border: 1px solid $color-transparent;
    line-height: normal;
    margin-left: 0;
    box-shadow: 0 0 0 0;

    &:hover {
      background: $theme-color-dark-secondary-button-hover;
      box-shadow: 0 0 0 0;
      border: 1px solid $theme-color-dark-secondary-button-hover;
    }

    &:active,
    &:focus {
      background: $theme-color-checkbox-disabled-checked-background;
      box-shadow: 0 0 0 0;
      border: 1px solid $theme-color-checkbox-disabled-checked-background;
    }

    &.isFocus {
      background: $theme-color-checkbox-disabled-checked-background;
      box-shadow: 0 0 0 0;
      border: 1px solid $theme-color-checkbox-disabled-checked-background;
    }
  }
}
